import GrpcService, { PlatformAdminApi } from 'src/services/GrpcService';

import {
  ICreate,
  ISearch,
  IUpdate,
  IRestore,
  IFindById,
  IRemove,
} from 'src/services/ServiceLocator/ServiceLocator.interface';
import { RequestController } from 'src/utils/decorators/request-controller';

class ManagerServiceProvider implements ISearch, ICreate, IUpdate, IRestore, IFindById, IRemove {
  @RequestController({ logger: true, retry: true, debounce: true })
  search(params: PlatformAdminApi.IManagerSearchRequest): Promise<PlatformAdminApi.ManagerSearchResponse> {
    return GrpcService.ManagementApiManagersService.Search(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  create(params: PlatformAdminApi.IManagerChangeRequest): Promise<PlatformAdminApi.ManagerFullResponse> {
    return GrpcService.ManagementApiManagersService.Create(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  update(params: PlatformAdminApi.IManagerChangeRequest): Promise<PlatformAdminApi.ManagerFullResponse> {
    return GrpcService.ManagementApiManagersService.Update(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  restore(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.ManagerFullResponse> {
    return GrpcService.ManagementApiManagersService.Restore(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  remove(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.ManagerFullResponse> {
    return GrpcService.ManagementApiManagersService.Remove(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  findById(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.ManagerFullResponse> {
    return GrpcService.ManagementApiManagersService.FindById(params);
  }
}

export const managerServiceProvider = new ManagerServiceProvider();
export type TManagerServiceProvider = typeof managerServiceProvider;
